import axios from 'axios';
import appConfig from '../config/api.config';
import { clearAuthToken, getAuthToken } from './authToken';

const url = appConfig.BASE_URL;
const request = axios.create({
  baseURL: `${url}/w1`,
  withCredentials: true,
  transformResponse: [(response) => {
    if (response) {
      const parsed = JSON.parse(response);
      if (parsed.error) return parsed;
      return parsed.data;
    }
    return null;
  }],
});

request.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      const isAuthPage = path.startsWith('/signin')
        || path.startsWith('/signup')
        || path.startsWith('/forgot-password');
      if (!isAuthPage) {
        clearAuthToken();
        window.location.replace('/signin');
      }
    }
    return Promise.reject(error);
  },
);

export default request;
